import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colors, sizes, media, helpers } from 'styles/variables';
import { logo } from 'styles/vectors';
import { log } from 'utils/log';
import { Link, navigate } from 'gatsby';
import firebase from 'gatsby-plugin-firebase';

export default props => {
	const [header] = useState(require(`data/header`));
	const [admin] = useState(require(`data/admin`));
	const [user, setUser] = useState(false);

	useEffect(() => {
		firebase.auth().onAuthStateChanged(function(user) {
			if (user) {
				setUser(true);
				window._email = user.email;
			} else {
				setUser(false);
				navigate('/profile');
			}
		});
	}, []);

	const StyledWrapper = styled.div`
		z-index: 9;
		display: grid;
		grid-template-columns: auto 1fr;
		grid-gap ${sizes[1]};
		padding: ${sizes[1]};
		align-items: center;
		background: ${colors.background[0]};
		${props.dark === true &&
			`
			background: #10120c;
		`}
		${helpers.shadow};
		${props.fixed === true && `position:fixed;top:0;left:0;right:0;`};
		${media.small} {
			font-size: 0.9rem;
		}
	`;
	const Logo = styled.div`
		text-align: left;
		svg {
			height: 44px;
			${media.small} {
				height: 34px;
			}
			width: auto;
			.fill1 {
				fill: ${colors.background[0]};
			}
			.fill2 {
				fill: ${colors.brand.base};
			}
			.fill3 {
				fill: ${colors.brand.dark};
			}
			${props.dark === true &&
				`
				.fill1 {
					fill: ${colors.background[0]};
				}
				.fill2 {
					fill: ${colors.teal.base};
				}
				.fill3 {
					fill: ${colors.brand.light};
				}
			`}
		}
	`;
	const Nav = styled.div`
		text-align: right;
		font-weight: 600;
		a {
			padding: ${sizes[1]};
			${media.small} {
				padding: ${sizes[1]};
				font-size: 0.85rem;
			}
			color: ${colors.foreground[1]};
			&:hover {
				color: ${colors.brand.base};
			}
			${props.dark === true &&
				`
				color:${colors.background[1]}
			`}
		}
	`;
	const SubNav = styled.div`
		width: calc(100% + ${sizes[1]} + ${sizes[1]});
		text-align: center;
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		// background: rgba(0, 0, 0, 0.025);
		font-size: 0.85rem;
		grid-column: span 2;
		margin: 0 -${sizes[1]} -${sizes[1]};
		a {
			padding: ${sizes[1]};
			border: 2px solid transparent;
			&.--active {
				color: ${colors.pink.base};
				border-bottom-color: ${colors.pink.base};
			}
		}
	`;

	const handleLogout = () => {
		firebase.auth().signOut();
	};

	return (
		<>
			<StyledWrapper>
				<Logo
					onClick={() => {
						log('Interaction', 'Header', 'click--logo');
					}}
				>
					<a href="/">{logo}</a>
				</Logo>
				<Nav>
					{header.map((item, index) => (
						<a
							href={item.link}
							target={item.link.indexOf('http') > -1 ? '_blank' : '_self'}
							key={index}
							onClick={() => {
								log(
									'Interaction',
									'Header',
									`click--${item.title
										.split(' ')
										.join('_')
										.toLowerCase()}`,
								);
							}}
						>
							{item.title}
						</a>
					))}
					{user ? (
						<a href="/profile" onClick={handleLogout}>
							Logout
						</a>
					) : (
						<></>
					)}
				</Nav>
				{user ? (
					<SubNav>
						{admin.map((item, index) => (
							<Link to={`/profile/${item.slug}`} key={index} activeClassName={'--active'}>
								{item.title}
							</Link>
						))}
					</SubNav>
				) : (
					<></>
				)}
			</StyledWrapper>
		</>
	);
};
